import { Trans } from "@lingui/macro";
import { Button, Row } from "@ster/ster-toolkit";
import { Col } from "antd";
import { ReactNode, memo, useCallback, useState } from "react";

import { CommercialsPerAdvertiser } from "../../../api";
import styles from "./AddOnlineInstructions.module.less";
import OnlineInstructionModal from "./OnlineInstructionModal";
import { OnlineInstructionsPerSubOrder, SimpleOnlineSubOrder } from "./types";

interface AddOnlineInstructionsProps {
  enabled: boolean;
  commercialsPerAdvertiser?: CommercialsPerAdvertiser;
  onOk?: () => void;
  maxDate: Date;
  okText?: ReactNode;
  onSave?: (instructions: OnlineInstructionsPerSubOrder[]) => void;
  newInstructionText?: ReactNode;
  newButtonMode?: "primary" | "secondary" | "tertiary" | "outline";
  subOrders: SimpleOnlineSubOrder[];
}

const AddOnlineInstructions = ({
  enabled,
  commercialsPerAdvertiser,
  onOk,
  maxDate,
  okText,
  onSave,
  newInstructionText,
  newButtonMode,
  subOrders,
}: AddOnlineInstructionsProps) => {
  const [showModal, setModal] = useState(false);

  const handleModalOpen = useCallback(() => {
    setModal(true);
  }, []);

  const handleModalCancel = useCallback(() => {
    setModal(false);
  }, []);

  const handleModalOk = useCallback(() => {
    setModal(false);
    if (onOk) {
      onOk();
    }
  }, [onOk]);

  return (
    <>
      {enabled && (
        <Row gutter={[40, 40]} className={styles.instructionButtonBarWrapper}>
          <Col span={24} className={styles.instructionButtonBar}>
            <Button mode={newButtonMode ?? "primary"} onClick={handleModalOpen}>
              {newInstructionText ?? <Trans>Nieuwe instructie</Trans>}
            </Button>
          </Col>
        </Row>
      )}

      {showModal && (
        <OnlineInstructionModal
          onCancel={handleModalCancel}
          onOk={handleModalOk}
          commercialsPerAdvertiser={commercialsPerAdvertiser}
          maxDate={maxDate}
          okText={okText}
          onSave={onSave}
          subOrders={subOrders}
        />
      )}
    </>
  );
};

export default memo(AddOnlineInstructions);
